module.exports = __webpack_public_path__ + "img/12-3.40cbd001.png";